import React from "react";
import { neturalBlack, netural400, netural50 } from "../../../constants/color";
import { formatCurrency } from "../../../utils/marketplaceHelpers";

const FinancialBreakdownCard = ({ feeBreakdown }) => {
  if (!feeBreakdown) return null;

  return (
    <div
      style={{
        border: "1px solid #DADADA",
        borderRadius: "12px",
        padding: "20px",
        backgroundColor: "#ffffff",
      }}
    >
      <div
        style={{
          fontSize: "18px",
          fontWeight: "600",
          color: neturalBlack,
          marginBottom: "20px",
        }}
      >
        Financial Breakdown
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span style={{ color: netural400, fontSize: "14px" }}>
            Gross Amount:
          </span>
          <span style={{ color: neturalBlack, fontSize: "14px", fontWeight: "500" }}>
            {formatCurrency(feeBreakdown.grossAmountDollars)}
          </span>
        </div>

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span style={{ color: netural400, fontSize: "14px" }}>
            Stripe Fee:
          </span>
          <span style={{ color: netural400, fontSize: "14px" }}>
            − {formatCurrency(feeBreakdown.stripeFeeDollars)}
          </span>
        </div>

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span style={{ color: netural400, fontSize: "14px" }}>
            Platform Fee:
          </span>
          <span style={{ color: netural400, fontSize: "14px" }}>
            − {formatCurrency(feeBreakdown.platformFeeDollars)}
          </span>
        </div>

        {feeBreakdown.platformBannerFeeDollars != null && (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ color: netural400, fontSize: "14px" }}>
              Banner Fee:
            </span>
            <span style={{ color: netural400, fontSize: "14px" }}>
              − {formatCurrency(feeBreakdown.platformBannerFeeDollars)}
            </span>
          </div>
        )}

        {feeBreakdown.platformBannerFeeTaxDollars != null && (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ color: netural400, fontSize: "14px" }}>
              Banner Fee Tax:
            </span>
            <span style={{ color: netural400, fontSize: "14px" }}>
              − {formatCurrency(feeBreakdown.platformBannerFeeTaxDollars)}
            </span>
          </div>
        )}

        {feeBreakdown.totalPlatformRevenueDollars != null && (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ color: netural400, fontSize: "14px" }}>
              Total Platform Revenue:
            </span>
            <span style={{ color: netural400, fontSize: "14px", fontWeight: "500" }}>
              {formatCurrency(feeBreakdown.totalPlatformRevenueDollars)}
            </span>
          </div>
        )}

        <div
          style={{
            borderTop: "2px solid #DADADA",
            marginTop: "8px",
            paddingTop: "12px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <span style={{ color: neturalBlack, fontSize: "16px", fontWeight: "600" }}>
            Net to Seller:
          </span>
          <span style={{ color: neturalBlack, fontSize: "16px", fontWeight: "600" }}>
            {formatCurrency(feeBreakdown.sellerAmountDollars)}
          </span>
        </div>

        <div
          style={{
            marginTop: "16px",
            paddingTop: "16px",
            borderTop: "1px solid #DADADA",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ color: netural400, fontSize: "13px" }}>
              Platform Rate:
            </span>
            <span style={{ color: netural400, fontSize: "13px" }}>
              {feeBreakdown.platformFeesRate}%
            </span>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ color: netural400, fontSize: "13px" }}>
              Seller gets:
            </span>
            <span style={{ color: netural400, fontSize: "13px" }}>
              {feeBreakdown.sellerPercentage?.toFixed(1)}%
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinancialBreakdownCard;
